import { render, staticRenderFns } from "./TransactionLog.vue?vue&type=template&id=711a2412&"
import script from "./TransactionLog.vue?vue&type=script&lang=js&"
export * from "./TransactionLog.vue?vue&type=script&lang=js&"
import style0 from "./TransactionLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports